import jsPDF from "jspdf";

export default function imprimirTurnosDiarios(
  source,
  nombreInstitucion,
  fecha
) {
  var doc = new jsPDF();
  let rows = [];
  const columnHeader = ["Hora", "Dni", "Jugador", "Estado"];

  source.forEach((element) => {
    var temp = [
      element.horaInicioString,
      element.dniPaciente,
      element.nombrePaciente,
      element.estadoTurnoString,
    ];
    rows.push(temp);
  });

  doc.setFontSize(12);
  doc.text(nombreInstitucion, 13, 10);
  doc.text("Fecha: " + fecha, 13, 22);
  doc.text("Cancha: " + source[0].nombreCancha, 13, 28);

  doc.setFontSize(16);
  doc.text("Listado de Turnos", doc.internal.pageSize.getWidth() / 2, 40, {
    align: "center",
  });

  doc.autoTable(columnHeader, rows, {
    startY: 46,
    didParseCell: function (table) {
      if (table.section === "head") {
        table.cell.styles.fillColor = "#c4c5c5";
      }
    },
  });
  window.open(doc.output("bloburl"), "_blank");
}
